export default "__VITE_ASSET__B97YVa$3__"